<template>
  <v-menu
    :min-width="menuWidth"
    :max-width="menuWidth"
    :disabled="$store.state.isWorkflowDisabled"
    scrim="true"
  >
    <template #activator="{ props }">
      <slot name="activator" :props="props">
        <v-avatar class="color-item" :color="color || 'rgb(238,238,238)'" v-bind="props" size="16"></v-avatar>
      </slot>
    </template>

    <div class="color-picker">
      <div :class="{'pa-1': appearance === 'diagram'}">
        <v-row class="flex-wrap justify-lg-space-between ma-1">
          <v-col
            cols="3"
            v-for="colorOption in colorOptions"
            :class="{
              'text-center': true,
              'pa-1': true,
              'mt-1': appearance !== 'diagram',
              'mb-1': appearance !== 'diagram'
            }"
            :key="computeRGBString(colorOption)"
          >
            <v-avatar
              class="color-item"
              :size="avatarSize"
              :color="computeRGBString(colorOption)"
              @click="$emit('change', colorOption)"
            >
              <v-icon size="small" :color="getForegroundColor(colorOption)" v-if="color === computeRGBString(colorOption)">mds:check</v-icon>
            </v-avatar>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </div>
    </div>
  </v-menu>
</template>

<script>
import { selectForegroundColor } from '@/utils/color'

export default {
  props: {
    color: String,
    variant: String, // options: 'cards', 'events'
    appearance: String // 'diagram', 'regular' [default]
  },

  data () {
    return {
      colors: {
        cards: [
          { red: 156, green: 43, blue: 246 },
          { red: 255, green: 162, blue: 110 },
          { red: 94, green: 206, blue: 248 },
          { red: 85, green: 227, blue: 142 },
          { red: 238, green: 120, blue: 120 },
          { red: 192, green: 77, blue: 202 },
          { red: 249, green: 216, blue: 98 },
          { red: 73, green: 87, blue: 212 },
          { red: 100, green: 171, blue: 67 },
          { red: 191, green: 73, blue: 101 }
        ],
        events: [
          { red: 255, green: 194, blue: 141 },
          { red: 255, green: 245, blue: 157 },
          { red: 189, green: 238, blue: 167 },
          { red: 183, green: 238, blue: 228 },
          { red: 167, green: 212, blue: 238 },
          { red: 193, green: 192, blue: 244 },
          { red: 236, green: 192, blue: 244 },
          { red: 206, green: 211, blue: 217 }
        ]
      }
    }
  },

  computed: {
    colorOptions () {
      return this.colors[this.variant] || []
    },

    menuWidth () {
      return this.appearance === 'diagram' ? '100' : '160'
    },

    avatarSize () {
      return this.appearance === 'diagram' ? '16' : '24'
    }
  },

  methods: {
    getForegroundColor (color) {
      return selectForegroundColor(color.red, color.green, color.blue)
    },

    computeRGBString (color) {
      return `rgb(${color.red},${color.green},${color.blue})`
    }
  }
}
</script>

<style scoped>
  .color-picker {
    border-radius: 8px;
    background-color: #FCFCFC;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  }

  .color-item {
    cursor: pointer;
  }
</style>
